import Input from './InputFieldEditable';
import makeReduxFormCompatible from 'components/common/makeReduxFormCompatible';

export default makeReduxFormCompatible({})(Input);
